export default __webpack_public_path__ + "static/tatva-e0516ec8db46c9e80a9a7f34b8f9ebc8.png";